"use client";
import React from "react";
import Image from "next/image";
//import { reduceImageDimension } from "@packages/lib/utlils/image-optimization/dimension-reducer";
import noImageSrc from "../../../../../apps/whatuni/public/static/assets/images/no_image.jpg";
import UserFavourite from "@packages/shared-components/common-utilities/user-favourite/UserFavourite";
const ImageAndLogoSection = ({
  cardItem,
  podInfo,
  commonGAAttrs,
  CSCommonData,
}: any) => {
  const getImgUrl = (path: string | undefined | null) => {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}${path}`;
  };

  const [uniImage, setUniImage] = React.useState<any>(
    getImgUrl(cardItem.image),
  );

  const [logoImage, setLogoImage] = React.useState<any>(
    getImgUrl(cardItem.logo),
  );
  
  return (
    <div className="card-header relative min-h-min lg:min-h-[345px] xl:min-h-[278px] bg-grey-200">
      {cardItem?.image ? (
        <Image
          src={uniImage}
          onError={() => {
            setUniImage(noImageSrc);
          }}
          width="392"
          height="221"
          className="block w-full min-h-[185px]"
          alt="Article_image"
        />
      ) : (
        <span className="card-header relative block w-full aspect-[311/221] lg:aspect-auto lg:min-h-[345px] xl:min-h-[278px] bg-blue-200"></span>
      )}
      <div className="absolute z-[1] top-[16px] left-[16px] rounded-[8px] overflow-hidden">
        <Image
          src={logoImage}
          onError={() => setLogoImage(noImageSrc)}
          width="64"
          height="64"
          alt="University logo"
        />
      </div>
      {cardItem?.isSponsored && (
        <div
          className="absolute z-[1] top-[16px] left-[calc(16px+64px+8px)] bg-white text-grey-500 uppercase rounded-[4px] px-[8px] py-0 font-inter text-[12px] leading-[18px] font-bold text-center h-[18px] flex items-center justify-center"
          id="sponsoredSection"
          data-collegename={cardItem?.collegeDisplayName}
          data-collegeid={cardItem?.collegeid}
        >
          sponsored
        </div>
      )}
      <div className="absolute z-[1] top-[16px] right-[16px]">
        <UserFavourite
          contentId={cardItem?.institutionId || cardItem?.courseId}
          contentName={cardItem?.institutionName || cardItem?.courseTitle}
          contentType="INSTITUTION"
          statsGAData={commonGAAttrs}
          //statsOldGAData={commonOldGAAttrs}
          clickStreamData={CSCommonData}
        />
      </div>
      {podInfo?.podType === "openDays" && cardItem?.eventType && (
        <div className="absolute left-[16px] bottom-[16px] flex gap-[6px] z-0">
          {cardItem?.eventType?.toLowerCase() !== "virtual tour" && (
            <div className="x-small font-bold text-grey-500 bg-grey-100 p-[0_8px] rounded-[4px] uppercase">
              {cardItem?.eventType}
            </div>
          )}
          {cardItem?.veppleFlag?.toLowerCase() === "y" && (
            <div className="x-small font-bold text-[#106519] bg-[#EEF2C0] p-[0_8px] rounded-[4px]">
              VIRTUAL TOURS AVAILABLE
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageAndLogoSection;
